import axios, { AxiosError } from "axios"

type response = { error?: string; message?: string }

export const createUser = async (username: string, profilePicUrl: string): Promise<response> => {
  try {
    const res = await axios.post<response>(`/users`, {
      username: username,
      profilePicUrl: profilePicUrl,
    })
    return res.data
  } catch (error) {
    return { error: error?.toString(), message: (error as AxiosError)?.response?.data?.message }
  }
}
